// Given a map, return a new map with only those keys from the list
import { List, Map } from "immutable";

export const listToMap = list => Map(list.map(v => [v.get("id"), v]));

export const mapValuesToArray = map => [...map.values()];

// These functions force the "map" variable into a Map type, in case it is a Record.
export const mapPick = (map, keys) => Map(map).filter((v, k) => keys.indexOf(k) >= 0);

// Given a map, return a new map with only those keys not in the list
export const mapOmit = (map, keys) => Map(map).filter((v, k) => keys.indexOf(k) < 0);

export const keySetFromMap = orig => orig.keySeq().toSet(); //orig.map((v, k) => k).toSet();
export const keyListFromMap = orig => orig.keySeq().toList(); //orig.map((v, k) => k).toList();
export const keyArrayFromMap = orig => orig.keySeq().toArray(); //orig.map((v, k) => k).toArray();

export const listUnion = (left, right) => {
  let list = [];
  let screen = {};
  for (let i = 0; i < left.length; i++) {
    if (!screen[left[i]]) list.push(i);
    screen[left[i]] = 1;
  }
  for (let i = 0; i < right.length; i++) {
    if (!screen[right[i]]) list.push(i);
    screen[right[i]] = 1;
  }
  return List(list);
};

export const listIntersection = (left, right) => {
  let list = [];
  let screen = {};
  for (let i = 0; i < left.length; i++) {
    screen[left[i]] = 1;
  }
  for (let i = 0; i < right.length; i++) {
    if (screen[right[i]]) {
      list.push(i);
    }
  }
  return List(list);
};

export const indexListBy = (iterable, searchKey) => {
  return iterable.reduce((lookup, item) => lookup.set(item.get(searchKey), item), Map());
};

export const listToIndexMap = ids =>
  Map(
    ids.reduce((result, id, index) => {
      result[id] = index;
      return result;
    }, {})
  );

export const doSetsIntersect = (set1, set2) =>
  set1.size > set2.size ? Boolean(set2.find(rId => set1.has(rId))) : Boolean(set1.find(rId => set2.has(rId)));
